module.exports = __webpack_public_path__ + "img/torrontes.443a88a6.jpg";